import { jsx as _jsx } from "react/jsx-runtime";
import { List as UIList } from "@bluframe/mightychroma-mightytool-ui";
const List = ({ hasSearch, isSearchLoading, items, label, loading, onAdd, onSearchChange }) => (_jsx(UIList, { hasSearch: hasSearch, isSearchLoading: isSearchLoading, items: items, label: label, loading: loading, onAdd: onAdd, onSearchChange: onSearchChange }));
export default List;
